/**
 * Function to convert a number number * 10^18
 * @param {Number} number 
 * @returns 
 */
export default function convertToSixDecimal(number) {
    let newNumber = Math.ceil(number * 10) / 10;
    return (newNumber * 1e6).toLocaleString("fullwide", { useGrouping: !1 })
}